import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { StyledH2, StyledModal } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { DynamicTable } from "@maherunlocker/custom-react-table";

import { store } from "@components/VerticalLayout/store";
import { setIds, setSelectedRow, store as dataStore } from "../store";

import ErrorToast from "@components/Common/ErrorTost";

import { ConfirmationMessage } from "./ConfirmationMessage";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import { generalConfigStore } from "@store";
import {
    arrayOfCustomColumnsPaymentModalAssociateModal,
    checkIfPaymentMethodExistAndArchived,
    CountIds,
    handleAssociatePaymentMethodsButtonClick,
} from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";
import { useAuthHeader } from "../../../../api/headersKeycloak";

type PaymentModalAssociateModalType = {
    selectedShopsRows: any;
    setIsAssociateModalOpened: Function;
    isAssociateModalOpened: boolean;
};

export function PaymentModalAssociateModal({
    selectedShopsRows,
    setIsAssociateModalOpened,
    isAssociateModalOpened,
}: PaymentModalAssociateModalType) {
    const { t } = useTranslation();
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const {
        idsLocalShop,
        activePaymentMethods,
        shopsSelectedRow,
        localShop,
        associatedPaymentMethods,
        salesSupports,
    } = useSnapshot(dataStore);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const getAuthHeader = useAuthHeader();
    const shopId = "0";
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const { fetchGlobal } = useFetchGlobal();
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [isValidateClicked, setIsValidateClicked] = React.useState<
        boolean | number
    >(false);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [isModalArchivedOpened, setIsModalArchivedOpened] = React.useState<
        boolean
    >(false);
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState<
        any[]
    >([]);
    const [
        isValidateButtonDisabled,
        setIsValidateButtonDisabled,
    ] = React.useState<boolean>(false);
    const url =
        localShop.length === 1
            ? `${
                  process.env.REACT_APP_API_V2_URL
              }/settings/general/filtered_archived_paymentMethod?userId=${userID}&shopId=${
                  localShop[0].id
              }&franchiseId=${franchiseID}&type=activated${`&paysQuery=${localShop[0].pays}`}`
            : `${
                  process.env.REACT_APP_API_V2_URL
              }/settings/general/filtered_archived_paymentMethod?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&paysQuery=${localShop
                  .map((el: any) => {
                      return el.pays;
                  })
                  .join(",")}`;

    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div> </div> : null;
    };

    React.useEffect(() => {
        let localSelectedPaymentMethod: any = [];
        selectedShopsRows.forEach((el: any) => {
            if (el.subRows !== undefined)
                el.subRows.forEach((element: any) => {
                    localSelectedPaymentMethod.push(element);
                });
        });
        setSelectedPaymentMethod(localSelectedPaymentMethod);
    }, [selectedShopsRows, selectedRows, activePaymentMethods]);

    React.useEffect(() => {
        if (isValidateClicked === true) {
            handleAssociatePaymentMethodsButtonClick(
                {
                    userID,
                    franchiseID,
                    operatorID,
                    uuidUser,
                },
                isAssociateModalOpened,
                setIsAssociateModalOpened,
                setIsValidateClicked,
                setSelectedRows,
                activePaymentMethods,
                salesSupports,
                selectedRows,
                selectedShopsRows,
                itemsDisable,
                shopsSelectedRow,
                isValidateButtonDisabled,
                setIsValidateButtonDisabled,
                fetchGlobal
            );
        }

        // eslint-disable-next-line
    }, [isValidateClicked]);

    return (
        <React.Fragment>
            <StyledModal
                toggle={true}
                isOpen={isAssociateModalOpened!}
                centered
                className="modal-wrapper__clz"
                backdrop="static"
                fade={false}
                scrollable
            >
                <ModalHeader
                    className="text-capitalize"
                    toggle={() => {
                        setIsAssociateModalOpened(!isAssociateModalOpened);
                    }}
                >
                    <StyledH2 className="text-uppercase mdr_txt_AFlistOfPaymentMethods">
                        {t("List of payment methods")}
                    </StyledH2>
                </ModalHeader>
                <ModalBody>
                    <DynamicTable
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        url={url}
                        canSelect
                        customSelect
                        canResize
                        setSelectedRows={setSelectedRows}
                        actionColumn={ActionColumn}
                        arrayOfCustomColumns={arrayOfCustomColumnsPaymentModalAssociateModal(
                            selectedShopsRows,
                            selectedPaymentMethod
                        )}
                        showGlobalFilter
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        elevationTable={1}
                        minHeight="500px"
                        maxHeight="500px"
                        name="associateModeOfSale"
                    />
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomSecondaryColorButton
                        outline
                        variant="light"
                        onClick={() => {
                            setIsAssociateModalOpened(!isAssociateModalOpened);
                        }}
                        rounded
                        className="mdr_btn_AFcancel"
                    >
                        {t("Cancel")}
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        className="mdr_btn_AFvalidate"
                        rounded
                        variant="primary"
                        onClick={() => {
                            let archived = checkIfPaymentMethodExistAndArchived(
                                shopsSelectedRow
                            );

                            if (selectedRows.length === 0) {
                                ErrorToast(
                                    `${t(
                                        "Attention ! You must select at least one payment method"
                                    )!}`
                                );
                            } else {
                                CountIds(idsLocalShop, selectedRows, setIds);

                                setSelectedRow(selectedRows);
                                selectedRows.forEach((el: any) => {
                                    associatedPaymentMethods.forEach(
                                        (element: any) => {
                                            if (
                                                element.id === el.id &&
                                                activePaymentMethods.find(
                                                    (elt: any) =>
                                                        elt.id === el.id
                                                ) &&
                                                element.isActive !==
                                                    activePaymentMethods.find(
                                                        (elt: any) =>
                                                            elt.id === el.id
                                                    ).state
                                            ) {
                                                setIsModalOpened(
                                                    !isModalOpened
                                                );
                                                // eslint-disable-next-line
                                                throw "Break";
                                            }
                                        }
                                    );
                                });
                                selectedRows.forEach((el: any) => {
                                    if (archived.includes(el.id)) {
                                        setIsModalArchivedOpened(
                                            !isModalArchivedOpened
                                        );
                                        // eslint-disable-next-line
                                        throw "Break";
                                    }
                                });

                                handleAssociatePaymentMethodsButtonClick(
                                    {
                                        userID,
                                        franchiseID,
                                        operatorID,
                                        uuidUser,
                                    },
                                    isAssociateModalOpened,
                                    setIsAssociateModalOpened,
                                    setIsValidateClicked,
                                    setSelectedRows,
                                    activePaymentMethods,
                                    salesSupports,
                                    selectedRows,
                                    selectedShopsRows,
                                    itemsDisable,
                                    shopsSelectedRow,
                                    isValidateButtonDisabled,
                                    setIsValidateButtonDisabled,
                                    fetchGlobal
                                );
                            }
                        }}
                    >
                        {" "}
                        {t("Validate")}{" "}
                    </CustomMainColorButton>
                </ModalFooter>
            </StyledModal>{" "}
            {isModalOpened ? (
                <ConfirmationMessage
                    msg={t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                    setIsModalOpened={setIsModalOpened}
                    isModalOpened={isModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}{" "}
            {isModalArchivedOpened ? (
                <ConfirmationMessage
                    msg={t(
                        "Attention! One or more selected payment methods are already assigned and archived at the store level.Would you unarchive them?"
                    )}
                    setIsModalOpened={setIsModalArchivedOpened}
                    isModalOpened={isModalArchivedOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}{" "}
        </React.Fragment>
    );
}
